import React from 'react';
import { Upload } from 'lucide-react';

const DragDropOverlay = ({ isVisible, size = 'default' }) => {
    if (!isVisible) return null;

    const isLarge = size === 'large';

    return (
        <div className="absolute inset-0 bg-blue-500/10 dark:bg-blue-500/20 backdrop-blur-sm flex items-center justify-center z-50 pointer-events-none">
            <div className={`bg-white dark:bg-gray-800 rounded-2xl shadow-2xl ${isLarge ? 'p-12 border-4' : 'p-8 border-2'} border-blue-500 dark:border-blue-400 border-dashed`}>
                <div className={`flex flex-col items-center ${isLarge ? 'gap-6' : 'gap-4'}`}>
                    <Upload
                        size={isLarge ? 64 : 48}
                        className="text-blue-500 dark:text-blue-400 animate-bounce"
                    />
                    <div className="text-center">
                        <p className={`${isLarge ? 'text-2xl' : 'text-lg'} font-semibold text-gray-900 dark:text-white ${isLarge ? 'mb-2' : 'mb-1'}`}>
                            Drop {isLarge ? 'your ' : ''}files here
                        </p>
                        <p className={`${isLarge ? 'text-base mb-1' : 'text-sm'} text-gray-${isLarge ? '600' : '500'} dark:text-gray-${isLarge ? '300' : '400'}`}>
                            Upload {isLarge ? 'documents, ' : ''}images, {isLarge ? 'audio, and more' : 'documents, audio, and more'}
                        </p>
                        {isLarge && (
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                Supported: PDF, Excel, Word, PowerPoint, Images, Audio, Video (max 20MB each)
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DragDropOverlay;
